/* istanbul ignore file - better tested e2e */

import { Step } from '@mui/material';
import { PageBrandedPanel } from '@partful/shared/ui/PageBrandedPanel';
import { PageNavigation } from '@partful/shared/ui/PageNavigation';
import { StandardPageHeader, StandardPageLayout, StandardPageMain } from '@partful/shared/ui/StandardPageLayout';
import { Typography } from '@partful/shared/ui/Typography';
import { VerticalStepLabel } from '@partful/shared/ui/VerticalStepLabel';
import { VerticalStepper } from '@partful/shared/ui/VerticalStepper';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import styles from './CreateInstructionsPage.module.scss';
import { DetailsPage } from './details';
import { GeneralAssemblyPage } from './general-assembly';
import { PreviewPage } from './preview/PreviewPage';
import { ProcessingPage } from './processing';

export function CreateInstructionsPage() {
  const { t: i18n } = useTranslation();
  const { pathname } = useLocation();

  const activeStep = useMemo(() => {
    switch (pathname) {
      case '/instructions/create/details':
        return 0;
      case '/instructions/create/general-assembly':
        return 1;
      case '/instructions/create/processing':
        return 2;
      case '/instructions/create/preview':
        return 3;
      default:
        return 0;
    }
  }, [pathname]);

  return (
    <StandardPageLayout>
      <StandardPageHeader>
        <PageBrandedPanel>
          <div className={styles.steps}>
            <Typography appearance="heading6">{i18n('instructions:create.steps.title')}</Typography>
            <VerticalStepper activeStep={activeStep}>
              <Step>
                <VerticalStepLabel>{i18n('instructions:create.steps.details')}</VerticalStepLabel>
              </Step>
              <Step>
                <VerticalStepLabel>{i18n('instructions:create.steps.generalAssembly')}</VerticalStepLabel>
              </Step>
              <Step>
                <VerticalStepLabel>{i18n('instructions:create.steps.processing')}</VerticalStepLabel>
              </Step>
              <Step>
                <VerticalStepLabel>{i18n('instructions:create.steps.preview')}</VerticalStepLabel>
              </Step>
            </VerticalStepper>
          </div>
        </PageBrandedPanel>
        <PageNavigation />
      </StandardPageHeader>
      <StandardPageMain>
        <Switch>
          <Route exact path="/instructions/create/details">
            <DetailsPage />
          </Route>
          <Route exact path="/instructions/create/general-assembly">
            <GeneralAssemblyPage />
          </Route>
          <Route exact path="/instructions/create/processing">
            <ProcessingPage />
          </Route>
          <Route exact path="/instructions/create/preview">
            <PreviewPage />
          </Route>
          <Redirect to="/instructions/create/details" />
        </Switch>
      </StandardPageMain>
    </StandardPageLayout>
  );
}
